"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var postSlice_1 = require("../../features/post/postSlice");
var react_redux_1 = require("react-redux");
var query_string_1 = __importDefault(require("query-string"));
var userSlice_1 = require("../../features/user/userSlice");
var uri_1 = require("../../helpers/uri");
var globalSlice_1 = require("../../features/global/globalSlice");
var NewPostForm_1 = __importDefault(require("./NewPostForm"));
var Routes_1 = require("../../constants/Routes");
var NewPostTabsContext_1 = require("./NewPostTabsContext");
var react_i18next_1 = require("react-i18next");
var NewPost = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var id = react_router_dom_1.useParams().id;
    var user = react_redux_1.useSelector(userSlice_1.useSelectUser);
    var phoneVerified = react_redux_1.useSelector(userSlice_1.useSelectUserHasVerifiedContacts);
    var queryParams = query_string_1.default.parse(window.location.search);
    var getOrCreatePost = function () { return __awaiter(void 0, void 0, void 0, function () {
        var post, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    if (id) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(postSlice_1.createPost(queryParams.subscription_plan_id))];
                case 1:
                    post = (_b.sent()).post;
                    history.replace(uri_1.createRoute({
                        path: Routes_1.Routes.EditAnnouncement.path,
                        params: { id: post.id },
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: 'Cannot create a post',
                        appearance: 'error',
                    }));
                    history.push(Routes_1.Routes.Home.path);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (user && !phoneVerified) {
            history.push(Routes_1.Routes.SmsVerification.path);
        }
    }, [user]);
    react_1.useEffect(function () {
        if (phoneVerified) {
            getOrCreatePost();
        }
    }, [phoneVerified, id]);
    if (!id) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(NewPostTabsContext_1.NewPostTabsContext, null,
        react_1.default.createElement(NewPostForm_1.default, null)));
};
exports.default = NewPost;
